// Some Chromium/Linux builds expose a POSIX locale that Intl rejects. uPlot
// reads navigator.language while its module loads, so normalize it first.
try {
  new Intl.NumberFormat(navigator.language).format(0)
} catch (error) {
  Object.defineProperty(navigator, 'language', {
    configurable: true,
    get: () => 'en-US'
  })
}
